module.exports = __webpack_public_path__ + "images/4081ab79b1fd06f37592220147967eda.jpg";